import Button, { ButtonVariant } from "../../components/ui/Button";

// 레거시 래퍼: 새 코드는 components/ui 의 Button 을 직접 사용한다.
interface MediumButtonProps {
  title: string;
  variant: "clear" | "primary" | "delete";
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const variantMap: Record<MediumButtonProps["variant"], ButtonVariant> = {
  clear: "outline",
  primary: "primary",
  delete: "danger",
};

export default function MediumButton(props: MediumButtonProps) {
  return (
    <Button
      size="md"
      variant={variantMap[props.variant]}
      onClick={(e) =>
        props.onClick(e as unknown as React.MouseEvent<HTMLDivElement>)
      }
    >
      {props.title}
    </Button>
  );
}
